// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpaceBadge__badges-ae7746 {
  align-items: center;
  display: flex;
  gap: 8px;
}

.SpaceBadge__mention-ef554b {
  width: 16px;
  height: 16px;
  margin-inline-end: 4px;
  fill: var(--brand-primary-40);
}

.SpaceBadge__pin-a91f05 {
  width: 24px;
  height: 24px;
  fill: var(--base-60);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SpacesList/SpaceBadge/SpaceBadge.styles.m.css"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,QAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,6BAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AACF","sourcesContent":[".badges {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n}\n\n.mention {\n  width: 16px;\n  height: 16px;\n  margin-inline-end: 4px;\n  fill: var(--brand-primary-40);\n}\n\n.pin {\n  width: 24px;\n  height: 24px;\n  fill: var(--base-60);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badges": `SpaceBadge__badges-ae7746`,
	"mention": `SpaceBadge__mention-ef554b`,
	"pin": `SpaceBadge__pin-a91f05`
};
module.exports = ___CSS_LOADER_EXPORT___;
